<template>
    <div>
      <div class="pay fa fa-dollar" @click="onClickShowPay"><span>觉得好用？支持作者</span></div>
      <transition name="fade">
        <div class="thanks" @click="onClickHidePay" v-show="showPay">
          <div class="thk_cont">
            <p>
              <img src="../../static/images/alipay.jpg" alt="">
              <strong>支付宝</strong>
            </p>
            <p>
              <img src="../../static/images/wx.jpg" alt="">
              <strong>微信</strong>
            </p>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
  export default {
    name: 'pay',
    data () {
      return {
        showPay:false
      }
    },
    methods: {
      onClickShowPay: function () {
        this.showPay = true;
      },
      onClickHidePay: function () {
        this.showPay = false;
      }
    }
  }
</script>

<style scoped>
  .pay { float:right; font-size:16px; cursor: pointer; line-height: 70px; padding-right:10px;  }
  .pay span { font-family: Helvetica, 'Pingfang SC', 'microsoft yahei'; }
  .pay:before { margin-right:5px; }

  .thanks { width:100%; height:100%; position: fixed; left:0; top:0; z-index: 10; background: rgba(0, 0, 0, 0.5); }
  .thk_cont { background: #ffffff; overflow: hidden; position: absolute; left:50%; top:50%; transform: translate(-50%, -50%); padding:15px 15px 5px 15px; }
  .thk_cont p { width:150px; float:left; }
  .thk_cont p:first-child { margin-right:15px; }
  .thk_cont img { width:100%; display: block; }
  .thk_cont strong { display: block; color:#2c3e50; text-align: center; font-size:14px; line-height: 2; }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */ {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/pay.vue